module.exports = __webpack_public_path__ + "img/p6.44e03f21.png";